import type { IntakeSpec, MechanicalShaftDetails } from '@shared/types';
import type { Part, Joint, Feature } from '@shared/spec';

function getDetails(intake: IntakeSpec): MechanicalShaftDetails {
  return intake.details as MechanicalShaftDetails;
}

export function parts(intake: IntakeSpec): Part[] {
  const d = getDetails(intake);
  return [
    {
      id: 'shaft',
      name: 'シャフト',
      kind: 'leg',
      materialId: 'mat-primary',
      length: intake.core.size?.length ?? 100,
      crossSection: { shape: 'circle', diameter: d.diameter },
      position: [0, 0, 0],
      rotation: [0, 0, 0],
      tags: ['shaft'],
      paramRefs: [],
    },
  ];
}

export function joints(_intake: IntakeSpec): Joint[] {
  return [];
}

export function features(intake: IntakeSpec): Feature[] {
  if (intake.qualityLevel === 'draft' || intake.qualityLevel === 'standard') return [];

  const d = getDetails(intake);
  const out: Feature[] = [];

  if (d.endStyle === 'chamfered' || d.endStyle === 'tapered') {
    out.push({
      id: 'end_chamfer',
      partId: 'shaft',
      kind: 'edge_treatment',
      treatment: 'chamfer',
      amount: 0.5,
      scope: 'all',
      position: [0, 0, 0],
      rotation: [0, 0, 0],
      paramRefs: [],
    });
  }

  // keyway: keyway feature kind is B2 rest, deferred.
  void d.keywayPresent;

  return out;
}
